<app-content>
  <app-error-bar></app-error-bar>
  <app-breadcrumbs>
    <li>
      <a routerLink='/wnioski-robocze' aria-label='Wnioski robocze'>
        Wnioski robocze
      </a>
    </li>
    <li>
      {{ serviceType()?.name || 'Ładowanie danych...' }}
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      {{ serviceType()?.name || '' }}
    </h2>
    <router-outlet></router-outlet>
    <div [innerHTML]="serviceType()?.editorFooterContent"></div>
  </section>
</app-content>
